export default [
  '+380 (68) 486-14-16',
  '+380 (50) 983-42-37',
  '+380 (97) 811-35-45',
  '+380 (97) 811-35-44',
  '+380 (99) 345-21-03',
];
